<template>
  <div class="container">
    <el-breadcrumb separator=">" class="title">
      <el-breadcrumb-item :to="{ path: '/student_list' }">学员管理</el-breadcrumb-item>
      <el-breadcrumb-item>学员详情</el-breadcrumb-item>
    </el-breadcrumb>
    <el-row :gutter="10" class="info-wrapper">
      <el-col :span="8" style="padding-left: 0">
        <div class="grid-content">
          <el-image :src="stuInfo.idPhoto" lazy class="avatar"></el-image>
          <el-form ref="form" disabled :model="stuInfo" label-width="100px">
            <el-form-item label="学员姓名">
              <el-input v-model="stuInfo.name"></el-input>
            </el-form-item>
            <el-form-item label="性别">
              <el-input v-model="stuInfo.genderDesc"></el-input>
            </el-form-item>
            <el-form-item label="手机号">
              <el-input v-model="stuInfo.phoneNo"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </el-col>
      <el-col :span="8" style="padding-left: 0">
        <div class="grid-content">
          <div class="avatar">&nbsp;</div>
          <el-form ref="form" disabled :model="stuInfo" label-width="100px">
            <el-form-item label="英文名">
              <el-input v-model="stuInfo.nameEnglish"></el-input>
            </el-form-item>
            <el-form-item label="生日">
              <el-input v-model="stuInfo.birthday"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </el-col>
    </el-row>
    <div class="info-title">课程信息</div>
    <el-row :gutter="10" class="info-wrapper">
      <el-col :span="8" style="padding-left: 0">
        <div class="grid-content">
          <el-form ref="form" disabled :model="courseInfo" label-width="100px">
            <el-form-item label="课程名称">
              <el-input v-model="courseInfo.courseName"></el-input>
            </el-form-item>
            <el-form-item label="库存所有者">
              <el-input v-model="courseInfo.ownerName"></el-input>
            </el-form-item>
            <el-form-item label="更新时间">
              <el-input v-model="courseInfo.entryTime"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </el-col>
      <el-col :span="8" style="padding-left: 0">
        <div class="grid-content">
          <el-form ref="form" disabled :model="courseInfo" label-width="100px">
            <el-form-item label="课程状态">
              <el-input v-model="courseInfo.courseStatusDesc"></el-input>
            </el-form-item>
            <el-form-item label="教练">
              <el-input v-model="courseInfo.insName"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </el-col>
    </el-row>
    <el-table
      class="table"
      :data="courseProcess"
    >
      <el-table-column
        prop="statusDesc"
        label="课程进度"
        align="center"
        width="150">
      </el-table-column>
      <el-table-column
        prop="entryTime"
        label="进度时间"
        align="center"
        width="150">
      </el-table-column>
    </el-table>
    <div class="info-title">&nbsp;</div>
  </div>
</template>

<script type="text/ecmascript-6">
  import { getStudentDetail } from '@/api/student';
  import { mapGetters } from 'vuex';

  export default {
    data() {
      return {
        stuInfo: {},
        courseInfo: {},
        courseProcess: []
      };
    },
    created() {
      this._getStudentDetail();
    },
    methods: {
      _getStudentDetail() {
        getStudentDetail(this.user.userId, this.$route.params.id).then((res) => {
          const { stuIno, courseInfo, courseProcess } = res;
          this.stuInfo = stuIno;
          this.courseInfo = courseInfo;
          this.courseProcess = courseProcess;
        });
      }
    },
    computed: {
      ...mapGetters([
        'user'
      ])
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus" rel="stylesheet/stylus">
  .container
    height: 100%;
    .title
      margin-bottom: 20px;
    .info-title
      margin-top: 20px;
      margin-bottom: 20px;
      font-weight: 400;
      font-size: 14px;
      color: #606266;
      cursor: text;
    .info-wrapper
      padding: 20px 20px 0 0;
      margin: 0 0 10px 0 !important;
      background: #fff;
      .avatar
        width: 174px;
        height: 216px;
        margin: 0 0 20px 20px;
        .image-slot
          height: 100%;
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
    .express-wrapper
      padding: 20px;
      background: #fff;
</style>